import React from 'react';
import { Box } from '@mui/material';
import { useFormikContext } from 'formik';
import DebounceTextField from '../../../../components/DebounceTextfield';
import { AgentInputType } from '../../../../types/AgentInputType.types';
import Agentv2 from '../../../../types/Agentv2.types';
import PanelCard from './PanelCard';

function NotesPanel() {
  const { values, handleChange, handleBlur, errors, touched } = useFormikContext<AgentInputType | Agentv2>();

  return (
    <Box>
      <PanelCard title="Notizen" subtitle="Interne Anmerkungen zum Berater">
        <DebounceTextField
          label="Notizen"
          name="notes"
          value={values.notes || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          variant="outlined"
          multiline
          minRows={12}
          helperText={errors.notes && touched.notes && errors.notes}
          error={Boolean(errors.notes && touched.notes) || false}
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
      </PanelCard>
    </Box>
  );
}

export default NotesPanel;
